import { SearchResponse } from '@cinch-nx/data-search'
import { useAnalytics } from '@cinch-nx/shared-analytics'
import cx from 'classnames'
import React from 'react'
import type { Makes } from '../../types/feature-home-page'
import type { HomeHeroV2 as HomeHeroV2Content } from '../../types/home-story-content'
import { HeroForm } from './hero-form'
import { HeroHeading } from './hero-heading/hero-heading'
import { HeroImage } from './hero-image'
import { HeroLink } from './hero-link/hero-link'
import { HeroSubheading } from './hero-subheading/hero-subheading'
import styles from './hero.module.css'

export type HeroProps = HomeHeroV2Content & {
  starRating: number
  starRatingLabel: string
  numberOfReviews: number
  totalStock: number
  makes: Makes[]
  shouldProdAdobeTargetTestRun?: boolean
  searchResponse?: SearchResponse
  storyFallback?: boolean
}

const HomeHeroV2: React.FC<HeroProps> = (props) => {
  const {
    makes,
    totalStock,
    starRating,
    starRatingLabel,
    heading,
    subheading,
    heroLink: [heroLink],
    image,
    isMobileImageShown,
    numberOfReviews,
    heroPartExchange,
    isHeroPromotional,
    storyFallback = false,
  } = props

  const { trackEvent } = useAnalytics()

  const { title, ctaText, label, placeholder, partExTextList } =
    heroPartExchange[0]

  const heroPartExTextList = partExTextList.map((item) => item.text)

  return (
    <section className={styles['container']} aria-describedby="hero-heading">
      <div
        className={cx(styles['background'], styles['backgroundGradient'], {
          [styles['backgroundGradientForPromo']]: isHeroPromotional,
        })}
      >
        <div className={styles['heroInner']}>
          <div
            className={cx(styles['textAndImageContainer'], {
              [styles['isMobileImageShown']]: isMobileImageShown,
            })}
          >
            <div className={styles['textContainer']}>
              <HeroHeading heading={heading} />
              <HeroSubheading subheading={subheading} />
              <HeroLink {...heroLink} trackEvent={trackEvent} />
            </div>
            <div className={styles['imageGridContainer']}>
              <HeroImage
                image={image}
                isMobileImageShown={isMobileImageShown}
                storyFallback={storyFallback}
              />
            </div>
          </div>
          {
            <HeroForm
              makes={makes}
              totalStock={totalStock}
              starRating={starRating}
              starRatingLabel={starRatingLabel}
              numberOfReviews={numberOfReviews}
              title={title}
              ctaText={ctaText}
              label={label}
              placeholder={placeholder}
              partExTextList={heroPartExTextList}
            />
          }
        </div>
      </div>
    </section>
  )
}

export default HomeHeroV2
